import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { applyLabel, unitFixBanner, UnitFixView } from '../../../../shared/services/sage-unit-fix.model';
import { UnitGroupView } from '../../../../shared/services/sage-unit-group.model';
import { UnitFixGroupComponent } from './unit-fix-group.component';

/** Units for the Sage items that didn't come in, grouped as in the first-sync wizard. Each choice is
 * saved as it's made, so Apply only adds the items. Shared by the web panel and the phone sheet. */
@Component({
  selector: 'app-unit-fix-panel',
  standalone: true,
  imports: [CommonModule, UnitFixGroupComponent],
  templateUrl: './unit-fix-panel.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './unit-fix-panel.component.css'],
})
export class UnitFixPanelComponent {
  @Input({ required: true }) view!: UnitFixView;
  @Input() syncEnabled = true;
  /** The web panel and the phone sheet are both in the page, so their field ids differ by this. */
  @Input() idPrefix = '';

  @Output() groupUnitChange = new EventEmitter<{ group: UnitGroupView; uomId: number }>();
  @Output() itemUnitChange = new EventEmitter<{ matchId: number; uomId: number }>();
  @Output() apply = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  readonly trackGroup = (_: number, group: UnitGroupView) => group.key;

  get banner(): { lead: string; rest: string } {
    return unitFixBanner(this.view.total);
  }

  get saving(): boolean {
    return this.view.applying || this.view.savingIds.size > 0;
  }

  get applyLabel(): string {
    return this.view.applying ? 'Applying…' : applyLabel(this.view.applyCount);
  }

  get canApply(): boolean {
    return this.view.applyCount > 0 && !this.saving && this.syncEnabled;
  }

  groupSaving(group: UnitGroupView): boolean {
    return this.view.applying || group.items.some((i) => this.view.savingIds.has(i.matchId));
  }
}
